var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "sidebar", attrs: { "select-cy": "nav" } },
    [
      _c(
        "router-link",
        {
          staticClass:
            "flex py-4 px-4 bg-white rounded-b justify-between wwf-logo",
          attrs: { to: "/" }
        },
        [
          _c("img", {
            staticClass: "cursor-pointer h-20",
            attrs: { src: require("@/assets/img/logo.svg") }
          })
        ]
      ),
      _c("div", { staticClass: "list flex flex-col h-full justify-between" }, [
        _c(
          "div",
          { staticClass: "mt-3" },
          [
            _c(
              "router-link",
              {
                staticClass: "link",
                class: { selected: _vm.isSelected("/home") },
                attrs: { to: "/home" }
              },
              [
                _c("i", { staticClass: "icn icn-home" }),
                _c("span", [_vm._v("Home")])
              ]
            ),
            _c(
              "router-link",
              {
                staticClass: "link",
                class: { selected: _vm.isSelected("/supporters") },
                attrs: { to: "/supporters", "select-cy": "supporters" }
              },
              [
                _c("i", { staticClass: "icn icn-support" }),
                _c("span", [_vm._v("Supporters")])
              ]
            ),
            _c(
              "router-link",
              {
                staticClass: "link",
                class: { selected: _vm.isSelected("/overview") },
                attrs: { to: "/overview" }
              },
              [
                _c("i", { staticClass: "icn icn-chart-pie" }),
                _c("span", [_vm._v("Overview")])
              ]
            ),
            _c(
              "router-link",
              {
                staticClass: "link",
                class: { selected: _vm.isSelected("/exports-data") },
                attrs: { to: "/exports-data" }
              },
              [
                _c("i", { staticClass: "icn icn-document-download" }),
                _c("span", [_vm._v("Exports Data")])
              ]
            )
          ],
          1
        ),
        _c("div", { staticClass: "pb-4" }, [
          _vm.hasAccess(_vm.settingModules) || _vm.isSuperAdmin
            ? _c(
                "div",
                {
                  staticClass: "section",
                  class: {
                    selected:
                      _vm.isSelected("/reports-management") ||
                      _vm.isSelected("/companies") ||
                      _vm.isSelected("/users") ||
                      _vm.isSelected("/security-groups") ||
                      _vm.isSelected("/roles")
                  },
                  attrs: { "select-cy": "settings" },
                  on: {
                    click: function($event) {
                      _vm.section === "settings"
                        ? (_vm.section = null)
                        : (_vm.section = "settings")
                    }
                  }
                },
                [
                  _vm._m(0),
                  _c("span", [_vm._v("Settings")]),
                  _vm.section != "settings"
                    ? _c("div", { staticClass: "icon chevron" }, [
                        _c("i", { staticClass: "icn icn-chevron-up" })
                      ])
                    : _vm._e(),
                  _vm.section === "settings"
                    ? _c("div", { staticClass: "icon chevron" }, [
                        _c("i", { staticClass: "icn icn-chevron-down" })
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm.section === "settings"
            ? _c(
                "div",
                { staticClass: "sub-links" },
                [
                  _vm.hasAccess(_vm.modules.USER)
                    ? _c(
                        "router-link",
                        {
                          staticClass: "link",
                          class: { selected: _vm.isSelected("/users") },
                          attrs: { to: "/users", "select-cy": "users" }
                        },
                        [
                          _c("i", { staticClass: "icn icn-users" }),
                          _c("span", [_vm._v("Users")])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "link cursor-pointer",
              on: {
                click: function($event) {
                  return _vm.logout()
                }
              }
            },
            [
              _c("i", { staticClass: "icn icn-logout" }),
              _c("span", [_vm._v("Sign out")])
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "icn icn-cog" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }